import type { Container } from "pixi.js";

export interface AmbienceInput {
  masterPeak: number;
  masterRms: number;
  /** 0..1 within the current beat */
  beatPhase: number;
  /** 0..1 within the current bar */
  barPhase: number;
  bpm: number;
  playing: boolean;
}

export interface HabitatVariant {
  timeOfDay: "dawn" | "day" | "dusk" | "night";
  /** In the deep sea, "snow" is marine snow, "rain" is a drifting plankton current, "mist" is murk. */
  weather: "clear" | "rain" | "mist" | "snow";
}

export interface HabitatOptions {
  width: number;
  height: number;
  seed: number;
  variant: HabitatVariant;
  reducedMotion: boolean;
  particles: boolean;
}

export interface Habitat {
  /** Background container: add it behind the creatures. */
  readonly view: Container;
  resize(w: number, h: number): void;
  setVariant(v: HabitatVariant): void;
  setMotion(reducedMotion: boolean, particles: boolean): void;
  /** dt in seconds. */
  update(dt: number, amb: AmbienceInput): void;
  /** pointer parallax / camera x offset -1..1 */
  setParallax(x: number, y: number): void;
  /** y in px (view-local) of the ground surface at x (0..1 of width), so creatures can stand on it. */
  groundY(xFraction: number): number;
  destroy(): void;
}

export const DEFAULT_VARIANT: HabitatVariant = { timeOfDay: "day", weather: "clear" };

export const SILENT_AMBIENCE: AmbienceInput = {
  masterPeak: 0,
  masterRms: 0,
  beatPhase: 0,
  barPhase: 0,
  bpm: 120,
  playing: false,
};
